<script>
    import {onMount} from 'svelte'      
    import Link from '../../router/Link.svelte'
    import {language} from '../../languages.js'
    import {getCurrentLocation} from '../../service'

    // export let router    
    
    
    function findStationNearme(){
        console.log('find stations ... ')
        let location = getCurrentLocation();
        location.subscribe( p=>{
            p.then(location=>{
                
                $$props.router.navigate('nearme',location)
            })
            .catch(err => {
                console.log(err)
            })
        })
    }
   
    localStorage.removeItem('searchcomp')

    onMount(()=>{
        // console.log($$props.router)        
        localStorage.removeItem('searchcomp')
    })
    
</script>

<div class="flex flex-col justify-center align-center items-center gap-2">
    <Link class="bg-green-500 rounded-lg w-8/12 text-white font-bold text-lg
            text-center p-2" to={'search'} {...$$props}>
        {$language.btn_search}
    </Link>
    <Link class="bg-green-500 rounded-lg w-8/12 text-white font-bold text-lg
            text-center p-2" to={'nearme'}>
                {$language.btn_search_nearme} 
    </Link>              
</div>
